(() => {
  const header = document.querySelector('[data-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 18);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('[data-mobile-nav] a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video[autoplay]').forEach((video) => { video.pause(); video.removeAttribute('autoplay'); });
  }

  document.querySelectorAll('img').forEach((image) => {
    image.addEventListener('error', () => image.closest('[data-product-card]')?.classList.add('has-image-error'), { once: true });
  });

  document.documentElement.dataset.maritaBuild = '1.0.0';
})();
